module.exports = __webpack_public_path__ + "static/img/yingyong.991a952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/yingyong.png
// module id = iZFH
// module chunks = 0